export const NEW_REQUESTS_COUNT = "NEW_REQUESTS_COUNT";
